import { REHYDRATE } from 'redux-persist/constants';
import _ from 'lodash';

import {
  ORDER_GUIDE_ASYNC_UPDATE_SUCCESS,
  ORDER_GUIDE_RESET_STATE,
  SET_LOADING_ORDER_GUIDE_STATUS,
  UPDATE_ORDER_GUIDE_PRICE,
} from 'actions/orderGuide';

const initialState = {
  firstRecNum: 0,
  lastRecNum: 0,
  totalNumRecs: 0,
  products: [],
  loading: false,
  opcoCustomerDate: '',
};

const actionsMap = {
  [ORDER_GUIDE_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    return action.data;
  },
  [ORDER_GUIDE_RESET_STATE]: () => {
    return initialState;
  },
  [SET_LOADING_ORDER_GUIDE_STATUS]: (state, action) => {
    return {
      ...state,
      loading: action.isLoading,
    };
  },
  [UPDATE_ORDER_GUIDE_PRICE]: (state, action) => {
    const priceList = action.data;
    const stateOrderGuide = state.products;
    _.forEach(priceList, orderGuidePrice => {
      const targetOrderGuide = _.find(stateOrderGuide,
        product => product.supc === orderGuidePrice.supc);
      targetOrderGuide.unitCost = orderGuidePrice.unitCost;
      targetOrderGuide.priceLoadSuccess = orderGuidePrice.priceLoadSuccess;
      targetOrderGuide.priceLoaded = orderGuidePrice.priceLoaded;
    });
    return {
      ...state,
      products: _.cloneDeep(stateOrderGuide),
    };
  },
  [REHYDRATE]: (state, action) => {
    const orderGuidePayload = action.payload.orderGuide;
    if (orderGuidePayload) {
      return orderGuidePayload;
    }
    return state;
  },
};

export default function orderGuide(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
